module.exports = __webpack_public_path__ + "img/image.cc70506f.png";